/**
 * Represents an empty map.
 * 
 * @type {ReadonlyMap<any, any>}
 */
export const EMPTY_MAP: ReadonlyMap<any, any> = new Map<any, any>();
